(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var STR = (window.rv && window.rv.strings) || { added: 'Ajouté au panier', adding: 'Ajout…' };

  /* ---------- mobile drawer ---------- */
  var drawer = $('#om-drawer');
  if (drawer) {
    $$('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { drawer.setAttribute('open', ''); drawer.removeAttribute('aria-hidden'); document.body.style.overflow = 'hidden'; }); });
    $$('[data-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }
  function closeDrawer() { if (!drawer) return; drawer.removeAttribute('open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  /* ---------- toast ---------- */
  var toast = $('#rv-toast'), toastTimer;
  function showToast(msg) {
    if (!toast) return;
    $('#rv-toast-msg').textContent = msg;
    toast.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-on'); }, 4000);
  }

  /* ---------- cart count ---------- */
  function refreshCartCount() {
    if (!window.rv) return;
    fetch(window.rv.routes.cartJson, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; }); })
      .catch(function () {});
  }

  /* ---------- product: ajax add to cart ---------- */
  $$('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      var btn = $('[type="submit"][name="add"]', form) || $('[type="submit"]', form);
      var label = btn ? btn.textContent : '';
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = STR.adding; }
      fetch(window.rv.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'Erreur');
          showToast(STR.added);
          refreshCartCount();
        })
        .catch(function (err) { showToast(err.message); })
        .finally(function () { if (btn) { btn.removeAttribute('aria-disabled'); btn.textContent = label; } });
    });
  });

  /* ---------- product: variant by size pills ---------- */
  $$('form[data-product-form]').forEach(function (form) {
    var idInput = $('input[name="id"], select[name="id"]', form);
    $$('.om-size input[type="radio"]', form).forEach(function (r) {
      r.addEventListener('change', function () {
        if (idInput && r.dataset.variant) idInput.value = r.dataset.variant;
        var priceEl = $('[data-price-now]');
        if (priceEl && r.dataset.price) priceEl.textContent = r.dataset.price;
      });
    });
  });

  /* ---------- product: gallery thumbs ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var main = $('[data-gallery-main]', g);
    $$('[data-gallery-thumb]', g).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-gallery-thumb]', g).forEach(function (x) { x.removeAttribute('aria-current'); });
        b.setAttribute('aria-current', 'true');
        if (main) { main.removeAttribute('srcset'); main.src = b.dataset.src; }
      });
    });
  });

  /* ---------- quantity steppers ---------- */
  $$('.rv-qty').forEach(function (q) {
    var input = $('input', q);
    $$('button', q).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value || '1', 10), min = parseInt(input.min || '0', 10);
        v = b.dataset.step === '-' ? Math.max(min, v - 1) : v + 1;
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---------- cart: auto-submit on change ---------- */
  var cartForm = $('form[data-cart-form]');
  if (cartForm) {
    $$('input[name^="updates"]', cartForm).forEach(function (i) {
      i.addEventListener('change', function () { cartForm.submit(); });
    });
  }

  /* ---------- addresses: preselect country ---------- */
  $$('select[name="address[country]"][data-default]').forEach(function (sel) {
    var v = sel.getAttribute('data-default');
    if (!v) return;
    Array.prototype.forEach.call(sel.options, function (o) { if (o.value === v || o.textContent === v) o.selected = true; });
  });
})();
